// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var PersonalDataService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PersonalDataService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get personal data list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    PersonalDataService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "properties/personal-data-list", params);
    };
    /**
     * Get an exportation file of personal data
     *
     * @since 1.0.0
     */
    PersonalDataService.prototype.getExport = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'properties/personal-data-list-export', params, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get all personal data of all properties
     *
     * @since 1.0.0
     *
     * @param
     */
    PersonalDataService.prototype.getPersonalData = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "properties/personal-data")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    PersonalDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PersonalDataService_Factory() { return new PersonalDataService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: PersonalDataService, providedIn: "root" });
    return PersonalDataService;
}());
export { PersonalDataService };
